import * as React from "react";
import type { SVGProps } from "react";
const SvgOverage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      fill="#FF0095"
      fillRule="evenodd"
      d="M15 5.1 10.9 1H5.1L1 5.1v5.8L5.1 15h5.8l4.1-4.1zm-7.55-.989h1.347v4.79H7.449zm1.569 6.88a.898.898 0 1 1-1.797 0 .898.898 0 0 1 1.797 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOverage;
